import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  mensaje: Subject<any> = this.modalService.mensajeError;
  showModal: Subject<boolean> = this.modalService.showModal;
  msg: any;
  constructor(
    private modalService: ModalService,
    private router: Router) { }

  ngOnInit() {
    this.modalService.mensajeError.subscribe(data => {
      this.msg = data;
    });
  }
  closeError() {
    this.router.navigate(['/intranet/home']);
    this.modalService.hide();
  }

}
